import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { timerDigitPairs } from '../../domain/countdown-bar.helpers';

@Component({
  selector: 'bingo-countdown-bar-timer',
  templateUrl: './countdown-bar-timer.html',
  styleUrl: './countdown-bar-timer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'countdown-bar__timer',
  },
})
export class CountdownBarTimerComponent {
  protected readonly timerDigitPairs = timerDigitPairs;
  readonly seconds = input.required<number>();
}
